<!-- 手机端 邀请公司-启翼邀请码 -->
<template>
  <div class="phone">
    <div class="card">
      <div class="card_title">
        <div class="compName">
          注册公司
          <span class="name_bg"></span>
        </div>
        <div class="title_msg">
          欢迎加入太行启翼。
        </div>
      </div>
      <div class="center">
        <div v-if="active == 1">
          <div class="LoginPhone">
            <div class="input">
              <div class="input_name">
                <span class="Required">*</span>手机号
              </div>
              <el-input
                v-model="phone"
                placeholder="必填"
                @input="phoneInput"
              ></el-input>
            </div>
            <div class="input">
              <div class="input_name">
                <span class="Required">*</span>验证码
              </div>
              <el-input v-model="pohoneCode" maxlength="6" placeholder="必填" class="name_getcode">
                <template slot="append">
                  <div class="input_name_in" @click="getCode" v-if="!count">
                    获取验证码
                  </div>
                  <div class="input_name_in" v-if="count">
                    {{ count }}秒后重发
                  </div>
                </template>
              </el-input>
            </div>
            <div class="input">
              <div class="input_name">
                 邀请码
              </div>
              <!-- 扫码进入时邀请码不可编辑 -->
              <el-input :disabled="!!info.promotionNum" v-model="promotionNum" placeholder="请输入邀请码" @blur="promotionNumBlur"></el-input>
            </div>
            <div class="erro" v-if="promotionNumError">*邀请码无效</div>

          </div>
          <div class="bottom_botton">
            <div :class="pohoneCode && phone && !promotionNumError ? 'next' : 'next_no'" @click="confirmPhone">
              下一步
            </div>
          </div>
        </div>

        <div v-if="active == 3" class="center_card">
          <div class="LoginPhone">
            <div class="input">
              <div class="input_name">
                <span class="Required">*</span>公司名称
              </div>
              <el-input v-model="companyName" placeholder="必填"></el-input>
            </div>
            <div class="input">
            <div class="input_name">
              <span class="Required">*</span>公司类型
            </div>
            <el-select size="medium" v-model="companyType" placeholder="必选" style="width: 100%">
              <el-option :value="0" label="维保公司"></el-option>
              <el-option :value="1" label="使用单位"></el-option>
            </el-select>
          </div>
          <div class="input">
            <div class="input_name">
              <span class="Required">*</span>电梯规模
            </div>
            <el-select size="medium" v-model="liftScale" placeholder="请选择公司电梯台数" style="width: 100%">
              <el-option :value="1" label="100台以下"></el-option>
              <el-option :value="2" label="100-500台"></el-option>
              <el-option :value="3" label="500-1000台"></el-option>
              <el-option :value="4" label="1000-2000台"></el-option>
              <el-option :value="5" label="2000台以上"></el-option>
            </el-select>
          </div>
          <div class="input">
            <div class="input_name">
              公司规模
            </div>
            <el-select size="medium" v-model="companyScale" placeholder="请选择公司人员数量" style="width: 100%">
              <el-option :value="1" label="20人以下"></el-option>
              <el-option :value="2" label="20-50人"></el-option>
              <el-option :value="3" label="50-100人"></el-option>
              <el-option :value="4" label="100-200人"></el-option>
              <el-option :value="5" label="200人以上"></el-option>
            </el-select>
          </div>
            <div class="input">
              <div class="input_name">社会统一信用代码</div>
              <el-input maxlength="18" v-model="maintainUnitCode" placeholder="请填写"></el-input>
            </div>
            <div class="input">
              <div class="input_name">单位联系人</div>
              <el-input maxlength="10" v-model="unitContactPerson" placeholder="请填写"></el-input>
            </div>
            <div class="input">
              <div class="input_name">单位电话</div>
              <el-input maxlength="15" v-model="unitPhone" placeholder="请填写"></el-input>
            </div>
            <div class="login_button">
              <div class="button" @click="active = 1">上一步</div>
              <div :class="(companyName && liftScale) ? 'button' : 'button_no'" @click="confirmCompany()">
                下一步
              </div>
            </div>
          </div>
        </div>

        <div v-if="active == 4" class="center_card">
          <div class="LoginPhone">
            <div class="suss_msg">
              <div>
                您已注册成功！
              </div>
              <div class="txt_msg">请您选择感兴趣的内容：</div>
              <div class="tag_x">
                <span class="tag_desc" :class="interests.includes(item.name) ? 'tag_desc_actived' : ''" v-for="item in tagList" :key="item.id" @click="tagChane(item)">
                  {{ item.name }}
                </span>
              </div>
              
              <div class="txt_tips">
                请前往手机应用商城下载“<span style="color: #b7282d;">太行启翼</span>”APP，并前往电脑端配置电梯及公司成员。
              </div>
              <div class="txt_tips">
                <div>电脑端网址：</div>
                <div>{{ qiyiUrl }} <span class="copy_Link" @click="copyLinkM">复制</span></div>
              </div>
            </div>
            <div class="login_button">
              <div class="button" :class="isCompleted ? 'button_no' : ''" @click="confirmTag()">完成</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  phoneverifyCode,
  usercheckPhone,
  invitationCode,
  checkPromotionNum,
  addInterested,
} from "../../../api/api";
import { checkPhone } from '@/utils/tools';

export default {
  name: "companyMobileCode",
  props: ['info'],
  data() {
    return {
      // 表单
      phone: "", // 手机号
      pohoneCode: "", // 验证码
      promotionNum: "", // 邀请码
      companyName: "", // 公司名称
      companyType: 0, // 公司类型
      liftScale: "", // 电梯规模
      companyScale: "", // 公司规模
      maintainUnitCode: '', // 社会信用代码
      unitContactPerson: '', // 单位联系人
      unitPhone: '', // 单位电话
      // 步骤条
      active: 1,
      // 验证码
      timer: null,
      count: null,

      // 邀请码
      promotionNumError: false,
      // 启翼网址
      qiyiUrl: "",
      // 标签
      tagList: [
        { id: 1, name: "电梯监测" },
        { id: 2, name: "电梯故障" },
        { id: 3, name: "保养工单" },
        { id: 4, name: "电梯报修" },
        { id: 5, name: "维保合同" },
        { id: 6, name: "配件管理" },
        { id: 7, name: "政府平台对接" },
      ],
      interests: [],
      companyId: "",
      qiyiToken: "",
      isCompleted: false,
    };
  },
  mounted () {
    if (this.info.type == 4) {
      this.qiyiUrl = process.env.VUE_APP_BUSINESS + "/#/home"
      this.promotionNum = this.info.promotionNum;
      this.promotionNumBlur();
    }
  },
  methods: {
    // 手机号
    phoneInput() {
      // 只能输入数字
      this.phone = this.phone.replace(/[^0-9.]/g, "");
    },
    // 点击获取验证码
    getCode() {
      if (checkPhone(this.phone)) {
        let params = {
          phone: this.phone,
          type: "Register",
        };
        phoneverifyCode(params).then((res) => {
          if (res.code == 200) {
            this.countdown();
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "手机号输入有误，请重新输入！",
        });
      }
    },
    // 60秒倒计时，验证码请求成功后开始
    countdown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count -= 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 邀请码
    async promotionNumBlur() {
      // 如果有值就需要校验是否有效
      if(!this.promotionNum) {
        this.promotionNumError = false;
        return;
      }
      let res = await checkPromotionNum({ promotionNum: this.promotionNum })
      if(res.code == 200) {
        this.promotionNumError = !res.data;
      } else {
        this.promotionNumError = true;
      }
    },
    // 提交手机信息
    async confirmPhone() {
      if(!this.phone || !this.pohoneCode) {
        return;
      }

      let res = await usercheckPhone({
        phone: this.phone,
        code: this.pohoneCode,
      })
      if (res.code == 200) {
        this.$notify.success({
          title: "成功",
          message: res.msg,
        });
        // 跳到下一步
        this.active = 3;
      }
    },
    // 提交公司信息
    async confirmCompany() {
      // 校验表单
      if (!this.companyName || !this.liftScale) {
        return
      }
      if (this.maintainUnitCode && !/[0-9a-zA-Z_]{18}/.test(this.maintainUnitCode)) {
        this.$notify.error({
          title: "错误",
          message: "社会信用代码必须是18位字母和数字",
        });
        return
      }
      if (this.unitPhone && !/[0-9\-]{8,15}/.test(this.unitPhone)) {
        this.$notify.error({
          title: "错误",
          message: "单位电话必须是数字",
        });
        return
      }

      let params = {
        phone: this.phone,
        promotionNum: this.promotionNum,
        
        companyName: this.companyName,
        companyType: this.companyType,
        liftScale: this.liftScale,
        companyScale: this.companyScale,
        maintainUnitCode: this.maintainUnitCode,
        unitContactPerson: this.unitContactPerson,
        unitPhone: this.unitPhone,
      };
      console.log(params)
      let res= await invitationCode(params)
      if (res.code == 200) {
        this.$notify.success({
          title: "成功",
          message: res.msg,
        });
        // pc可以免登录跳转到启翼
        this.companyId = res.data.companyId;
        this.qiyiToken = res.data.token;

        this.active = 4;
      } else {
        this.$notify.error({
          title: "失败",
          message: res.msg,
        });
      }
    },
    // 标签
    tagChane(e) {
      // 如果已经完成 则不能操作
      if(this.isCompleted) {
        return;
      }

      if(this.interests.length) {
        const index = this.interests.indexOf(e.name);
        if(index === -1) {
          // 不存在 则添加
          this.interests.push(e.name);
        } else {
          // 存在 则移除
          this.interests.splice(index, 1);
        }
      } else {
        this.interests.push(e.name);
      }
    },
    // 复制网址
    copyLinkM() {
      // let this_ = this;
      // var save = function (e) {
      //   e.clipboardData.setData("text/plain", this_.qiyiUrl);
      //   e.preventDefault();
      // };
      // document.addEventListener("copy", save);
      // document.execCommand("copy");
      // document.removeEventListener("copy", save);
      // this.$notify.success({
      //   title: "成功",
      //   message: "复制成功",
      // });
      navigator.clipboard.writeText(this.qiyiUrl)
        .then(() => {
          alert('复制成功！');
        })
        .catch((err) => {
          console.error('复制失败：', err);
          fallbackCopy(); // 失败时调用兼容方法
        });

      // 兼容旧浏览器的回退方法
      const fallbackCopy = () => {
        const $temp = $('<textarea>');
        $('body').append($temp);
        $temp.val(this.qiyiUrl).select();
        try {
          document.execCommand('copy');
          alert('复制成功！');
        } catch (err) {
          alert('复制失败，请手动复制！');
        } finally {
          $temp.remove();
        }
      }
    },
    // 完成
    async confirmTag() {
      // 完成按钮只能点击一次
      if(this.isCompleted) {
        return;
      }

      let res = await addInterested({
        companyId: this.companyId,
        interests: this.interests,
      })
      if (res.code == 200) {
        this.isCompleted = true;
      } else {
        this.isCompleted = false;
        this.$notify.error({
          title: "失败",
          message: res.msg,
        });
      }
    }    
  },
};
</script>

<style lang="scss" scoped>
input,
input:focus,
textarea,
textarea:focus,
select,
select:focus {
  font-size: 16px !important;
}

.LoginPhone :deep(.el-input-group__append, .el-input-group__prepend) {
  background-color: #fff !important;
  color: #b7282d;
}

.LoginPhone
  :deep(.el-input-group__append:focus, .el-input-group__prepend:focus) {
  user-select: none !important;
  cursor: pointer !important;
}
.phone {
  // height: 100vh;
  width: 100%;
  background: url("../../../assets/IMG/registration/phone_bg.png") no-repeat;
  background-size: 100%;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  .card {
    box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.1);
    border-radius: 0.75rem;
    width: 21.4375rem;
    min-height: 34.4375rem;

    margin-top: 5.5rem;
    margin-bottom: 2rem;
    padding: 2rem;
    box-sizing: border-box;
    background: url("../../../assets/IMG/login/bg_ele.png") no-repeat;
    background-size: 100%;
    background-position: bottom;
    background-color: #fff;
    .card_title {
      .compName {
        display: inline-flex;
        flex-direction: column;
        font-size: 1.0625rem;
        font-weight: 600;
        color: #b7282d;
        position: relative;
        .name_bg {
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 0;
          height: 13px;
          background: rgba(183, 40, 45, 0.1);
        }
      }
      .title_msg {
        font-size: 9px;
        margin-top: 0.375rem;
      }
    }

    .center {
      margin-top: 3rem;
      .LoginPhone {
        width: 100%;
        .title {
          font-weight: 400;
          font-size: 1.25rem;
          line-height: 1.75rem;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 3.75rem;
        }
        .input {
          position: relative;
          padding: 1.25rem 0 0.625rem 0;
          .input_name {
            z-index: 5;
            position: absolute;
            color: #999999;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.375rem;
            background: #fff;
            left: 5%;
            top: 0.375rem;
          }

          .input_name_in {
            width: 100%;
            height: 100%;
            user-select: none;
            cursor: pointer;
          }
        }

        .erro {
          user-select: none;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 1.0625rem;
          color: #f84638;
        }

        .copy_Link {
          cursor: pointer;
          color: #b7282d;
          text-decoration: underline;
          margin-left: 10px;
        }

        .login_button {
          user-select: none;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 3.75rem;

          .button,
          .button_no {
            margin-right: 10px;
            cursor: pointer;
            width: 4rem;
            height: 2rem;
            border-radius: 0.25rem;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .button {
            background: #b7282d;
          }
          .button_no {
            background: #ccc;
          }
        }
        // 第三板块
        .suss_msg {
          font-weight: 400;
          font-size: 1.625rem;
          color: #333333;
          .txt_msg {
            font-size: 1rem;
            margin-top: 20px;
          }
          .tag_x {
            margin-top: 20px;
            display: flex;
            font-size: 12px;
            flex-flow: row wrap;
            .tag_desc {
              margin-right: 10px;
              margin-bottom: 10px;
              padding: 4px 14px;
              background: #F2F2F2;
              border-radius: 50px;
              cursor: pointer;
            }
            .tag_desc_actived {
              color: #fff;
              background: #b7282d;
            }
          }
          .txt_tips {
            font-size: 12px;
            margin-top: 10px;
          }
        }
        .avatar-uploader {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .avatar-uploader .el-upload {
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader-icon {
          font-size: 1.75rem;
          color: #8c939d;
          width: 5.5rem;
          height: 5.5rem;
          line-height: 5.5rem;
          text-align: center;
          border: 0.0625rem dashed #ccc;
          border-radius: 0.375rem;
        }
        .avatar {
          width: 5.5rem;
          height: 5.5rem;
          display: block;
        }
      }
    }
    .center_card {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .img_sess {
        width: 8.0625rem;
        height: 7.9375rem;
      }
      .sess_msg {
        color: #333333;
        font-weight: 400;
        font-size: 0.9375rem;
        margin-top: 1.5rem;
      }
    }

    .bottom_botton {
      margin-top: 4.375rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .next {
        width: 17.4375rem;
        height: 2.3125rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1.1875rem;
        background-color: #b7282d;
        color: #fff;
        font-size: 0.9375rem;
      }

      .back {
        font-weight: bold;
        font-size: 0.9375rem;
        color: #b7282d;
        text-decoration: underline;
        margin-top: 1rem;
      }
      .next_no {
        width: 17.4375rem;
        height: 2.3125rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1.1875rem;
        background-color: #e5e5e5;
        color: #999;
        font-size: 0.9375rem;
      }
    }
  }
}
</style>